import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntSystemDevIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8 10L8.4 14.6L7 16L1 10L7 4L8.4 5.4L3.8 10ZM16.2 10L11.6 14.6L13 16L19 10L13 4L11.6 5.4L16.2 10Z"
      />
    </SntIcon>
  );
};

export default SntSystemDevIcon;
